import React from 'react'
import {FiChevronRight} from "react-icons/fi";


const ListButton = ({ leftIcon ,title, subtitle, onClick,bgIconColor=null }) => {
    return (
        <button
          onClick={onClick}
          className="w-full p-4 flex items-center justify-between bg-white border border-gray-100"
        >
            <div className="flex items-center gap-4">
                <div className={`min-w-12 min-h-12 rounded-xl ${bgIconColor ? bgIconColor :'text-gray-50'}  flex items-center justify-center ml-3`}>
                {leftIcon}
                </div>
                <div className="text-left">
                <h3 className="font-semibold text-gray-900">{title}</h3>
                {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
                </div>
            </div>
    
            <FiChevronRight size={20} className="text-gray-400" />
        </button>
      );
}

export default ListButton
